import styled from "styled-components";
import tw from "twin.macro";

export const StyledFoundationLogo = styled.img.attrs({
    className: 'foundation-logo'
})`
    ${tw`w-56 `}
`